import type { DateRange } from "@edaz/edazkit/DateRangeInput";
import { Type } from "class-transformer";
import { startOfEDAZ } from "config";
import { addDays, endOfDay, startOfDay, subDays } from "date-fns";
import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

export default class DateRangeRequest implements DateRange {
  @observable
  @Type(() => Date)
  from?: Date;

  @observable
  @Type(() => Date)
  to?: Date;
}

export const DateRangeValidationRules: EntityValidationRules<DateRangeRequest> = {
  from: {
    required: true,
    isBefore: {
      condition: (entity: DateRangeRequest) => entity.to,
    },
    isAfter: {
      after: endOfDay(subDays(new Date("2020-11-01") ?? startOfEDAZ, 1)),
    },
  },
  to: {
    required: true,
    isAfter: {
      condition: (entity: DateRangeRequest) => entity.from,
    },
    isBefore: {
      before: startOfDay(addDays(new Date(), 1)),
    },
  },
};

export const OptionalDateRangeSameDayAllowedValidationRules: EntityValidationRules<DateRangeRequest> = {
  from: {
    isBefore: {
      condition: (entity: DateRangeRequest) => {
        if (entity.to) {
          const oneDayLaterDate = new Date(entity.to);
          oneDayLaterDate.setDate(oneDayLaterDate.getDate() + 1);

          return oneDayLaterDate;
        }

        return undefined;
      },
    },
  },
  to: {
    isAfter: {
      condition: (entity: DateRangeRequest) => {
        if (entity.from) {
          const oneDayEarlierDate = new Date(entity.from);
          oneDayEarlierDate.setDate(oneDayEarlierDate.getDate() - 1);

          return oneDayEarlierDate;
        }

        return undefined;
      },
    },
  },
};
